import { RecentDocumentItemViewModel } from "client/Api/Documents/SharePoint/common";
import { BookmarkModel } from "client/Api/Documents/Bookmarks/bookmarks";
import { Guid } from "client_legacy/ndaw/guid";
import { environmentHttpClient as httpClient } from "client/Api/httpClient";

export enum FolderIdentifierKind {
	Recent = 1,
	Bookmarks = 2,
	SharePointFolder = 3,
	WebDavFolder = 4
}

export type RecentFolder = {
	kind: FolderIdentifierKind.Recent;
};

export type BookmarksFolder = {
	kind: FolderIdentifierKind.Bookmarks;
};

export type SharePointSpecificFolder = {
	kind: FolderIdentifierKind.SharePointFolder;
	siteUrl: string;
	listId: Guid;
	id: number | null;
	name: string;
};

export type WebDavSpecificFolder = {
	kind: FolderIdentifierKind.WebDavFolder;
	serverId: number;
	id: string;
	name: string;
};

export type FolderIdentifier =
	| RecentFolder
	| BookmarksFolder
	| SharePointSpecificFolder
	| WebDavSpecificFolder;

export function listRecentDocuments(): Promise<RecentDocumentItemViewModel[]> {
	return httpClient.get<RecentDocumentItemViewModel[]>(
		"Workspace/LiveInformation/Documents/ListRecentDocuments"
	);
}

export function listTopBookmarks(): Promise<BookmarkModel[]> {
	return httpClient.get<BookmarkModel[]>(
		"Workspace/LiveInformation/Documents/ListTopBookmarks"
	);
}